// src/WarmCommon.tsx
import { useEffect, memo } from 'react';
import { prefetchDashboard, prefetchClients, prefetchAgents } from '../prefetch/api';
import { getActiveCompanySlug } from '../utils/companySlug';

function WarmCommon() {
  useEffect(() => {
    const company = getActiveCompanySlug();
    if (!company) return;

    prefetchDashboard(company);
    prefetchClients(company, { page: 1, pageSize: 25 });
    prefetchAgents(company,  { page: 1, pageSize: 10 });
  }, []);

  return null;
}

export default memo(WarmCommon);
